/**
 * @module constants/cookieNames
 *
 * The cookie names that the Origin website uses are sometimes non-obvious. This file acts as a nice abstraction so
 * we don't need to hard-code them all throughout the app.
 */

/**
 * The region from which the user is visiting (i.e.: which Australian state, eg: "vic" / "tas")
 * @type {string}
 */
export const USER_REGION = 'target_state';

/**
 * Maintains which "universe" the user is on (eg: for home / for business / blog)
 * @type {string}
 */
export const SITE_UNIVERSE = 'universe_cookie';

/**
 * Indicates if the user is logged-in or not
 * @type {string}
 */
export const IS_LOGGED_IN = 'is-logged-in';
